import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { OrderDirection } from '../../Datatable/OrderDirection';
import CareModel from '../models/CareModel';
import { QueryItem } from '../../Tonnage/models/TonnageQueryModel';
import CareQueryModel from '../models/CareQueryModel';

interface CareSearchState {
    query: CareQueryModel,
    searchResults: CareModel[],
    triggerSearch: number,
    selectedCares: CareModel[],
    datatableSelectedIndex: number,
    searchResultTotalRecord: number,
    triggerFocusCompanyName: number
    checkedCares: CareModel[],
}

const initialState: CareSearchState = {
    query: {
        year: new Date().getFullYear(),
        clientNames: [],
        countries: [],
        city: "",
        picName: "",
        broker: 0,
        classifications: [],
        orderBy: "updatedDate",
        orderDirection: OrderDirection.Desc,
    } as CareQueryModel,
    searchResults: [],
    selectedCares: [],
    triggerSearch: 0,
    datatableSelectedIndex: -1,
    searchResultTotalRecord: 0,
    triggerFocusCompanyName: 0,
    checkedCares: []
}

export const CareSearchSlice = createSlice({
    name: "CareSearch",
    initialState,
    reducers: {
        setYear: (state, action: PayloadAction<number>) => {
            state.query.year = action.payload;
        },
        setClientNames: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.clientNames = action.payload;
        },
        setCountries: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.countries = action.payload;
        },
        setCity: (state, action: PayloadAction<string>) => {
            state.query.city = action.payload;
        },
        setPicName: (state, action: PayloadAction<string>) => {
            state.query.picName = action.payload;
        },
        setBroker: (state, action: PayloadAction<number>) => {
            state.query.broker = action.payload;
        },
        setClassifications: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.classifications = action.payload;
        },
        setOrderBy: (state, action: PayloadAction<string>) => {
            state.query.orderBy = action.payload;
        },
        setOrderDirection: (state, action: PayloadAction<OrderDirection>) => {
            state.query.orderDirection = action.payload;
        },
        setCareSearchResults: (state, action: PayloadAction<CareModel[]>) => {
            state.searchResults = action.payload;
        },
        setTriggerCareSearch: (state, action: PayloadAction<number>) => {
            state.triggerSearch = action.payload;
        },
        setDatatableSelectedCareIndex: (state, action: PayloadAction<number>) => {
            state.datatableSelectedIndex = action.payload;
        },
        setSearchResultTotalRecord: (state, action: PayloadAction<number>) => {
            state.searchResultTotalRecord = action.payload;
        },
        setCarequery: (state, action: PayloadAction<CareQueryModel>) => {
            state.query = action.payload;
        },
        resetCareSearch: (state) => {
            state.query = initialState.query;
        },
        setSelectedCares: (state, action: PayloadAction<CareModel[]>) => {
            state.selectedCares = action.payload;
        },
        setTriggerFocusCompanyName: (state, action: PayloadAction<number>) => {
            state.triggerFocusCompanyName = action.payload;
        },
        setCheckedCares: (state, action: PayloadAction<CareModel[]>) => {
            state.checkedCares = action.payload;
        },
    }
});

export const CareSearchSelector = createSelector(
    (state: RootState) => state.careSearch,
    (data) => data
);

export const {
    setYear,
    setClientNames,
    setCountries,
    setCity,
    setPicName,
    setBroker,
    setClassifications,
    setOrderBy,
    setOrderDirection,
    setCareSearchResults,
    setTriggerCareSearch,
    setDatatableSelectedCareIndex,
    setSearchResultTotalRecord,
    setCarequery,
    resetCareSearch,
    setSelectedCares,
    setTriggerFocusCompanyName,
    setCheckedCares
} = CareSearchSlice.actions;

export default CareSearchSlice.reducer;